import { render, staticRenderFns } from "./stroeValue.vue?vue&type=template&id=467bf7b2&scoped=true"
import script from "./stroeValue.vue?vue&type=script&lang=js"
export * from "./stroeValue.vue?vue&type=script&lang=js"
import style0 from "./stroeValue.vue?vue&type=style&index=0&id=467bf7b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467bf7b2",
  null
  
)

export default component.exports